
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("11pNz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $9b1c3000d033b19c$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $9b1c3000d033b19c$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $9b1c3000d033b19c$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $cNrxd = parcelRequire("cNrxd");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $6s1PB = parcelRequire("6s1PB");

var $luzsA = parcelRequire("luzsA");
const $9b1c3000d033b19c$export$fed0052f40119df3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JSW_BOARD_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JSW_BOARD_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JSW_BOARD_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $cNrxd.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Board critical early fetch failed'
            });
            return preload.data.boardScope;
        });
    }
    return null;
};
const $9b1c3000d033b19c$export$8134c072fddab6a5 = (baseUrl, boardId, filterJql)=>{
    const earlyPreload = $9b1c3000d033b19c$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    return (0, $luzsA.fetchBoardData)(baseUrl, boardId || '', filterJql);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b1c3000d033b19c$export$2e2bcd8739ae039 = async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    if (!(0, $9NiTW.checkAuthentication)(tenantContext) || !match.params.boardId) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    if (!(0, $3RV1W.checkLicense)(tenantContext, 'software')) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'License check failed',
        name: 'AuthenticationError',
        skipSentry: true
    });
    const { baseUrl: baseUrl } = tenantContext;
    const filterJql = (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) ? query.jql : undefined;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const data = await $9b1c3000d033b19c$export$8134c072fddab6a5(baseUrl, match.params.boardId, filterJql);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.software-boards.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $dJl1T = parcelRequire("dJl1T");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $dJl1T.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});

parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("luzsA", function(module, exports) {

$parcel$export(module.exports, "fetchBoardData", () => $9dbb7d1ba2164e90$export$c454496371605af);
/* eslint-disable jira/import-whitelist */ /**
 * This is a duplicate of ./index.js with a reduced surface area to limit bundle
 * size for testing a new approach to route-based critical data fetching.
 * See https://jdog.jira-dev.com/jira/software/projects/SPAF/boards/3052?selectedIssue=SPAF-22
 */ 
var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $71VJw = parcelRequire("71VJw");
const $9dbb7d1ba2164e90$export$c454496371605af = (baseUrl, rapidViewId, filterJql)=>(0, $71VJw.default)(baseUrl, rapidViewId, filterJql).toPromise().then((data)=>{
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    });

});
parcelRegister("71VJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81dd50241c07ede$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $fy8gS = parcelRequire("fy8gS");

var $cBLvH = parcelRequire("cBLvH");

var $6s1PB = parcelRequire("6s1PB");

var $l9rGV = parcelRequire("l9rGV");
const $b81dd50241c07ede$export$ba14d9a5a581e827 = (result)=>(0, $kVLXA.Observable).of(result.boardScope);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b81dd50241c07ede$export$2e2bcd8739ae039 = (contextPath, boardId, filterJql)=>(0, $cBLvH.query$)(contextPath, (0, $fy8gS.softwareBoardScopeCriticalDataOperationName), (0, $fy8gS.getBoardScopeGraphqlQuery)(), {
        boardId: boardId,
        useBackendIccConfig: (0, $4R6GH.fg)('use_backend_tmp_icc_config_'),
        showIssueTransition: (0, $4R6GH.fg)('issue_transition_screen_in_jsw_tmp_board'),
        hasJqlFilter: Boolean((0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) && filterJql),
        filterJql: filterJql
    }, (0, $l9rGV.boardScopeDataCriticalAnalyticsOptions)).flatMap($b81dd50241c07ede$export$ba14d9a5a581e827);

});
parcelRegister("fy8gS", function(module, exports) {

$parcel$export(module.exports, "softwareBoardScopeCriticalDataOperationName", () => $557b489490412bcc$export$33da63e9ed5a1c48);
$parcel$export(module.exports, "columnStatus", () => $557b489490412bcc$export$48a92d19f93c7dd6);
$parcel$export(module.exports, "getBoardScopeGraphqlQuery", () => $557b489490412bcc$export$f2f3dcc8e95c3168);
/*!
 * ATTENTION
 *
 * This module is used on both the main board app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $557b489490412bcc$export$33da63e9ed5a1c48 = 'SoftwareBoardScopeCriticalData';
const $557b489490412bcc$export$225522b2e3455b2 = `
        editConfig {
            inlineColumnEdit {
                enabled
            }
            inlineIssueCreate @skip(if: $useBackendIccConfig){
                enabled
            }
        }
    `;
const $557b489490412bcc$export$48a92d19f93c7dd6 = `columnStatus {
            status {
                id
                name
                category
            }
            transitions {
                id
                name
                status {
                    id
                }
                originStatus { id }
                cardType { id }
                isGlobal
                isInitial
                hasConditions
				hasScreen @include(if: $showIssueTransition)
            }
        }`;
const $557b489490412bcc$export$f2f3dcc8e95c3168 = ()=>{
    const issueChildren = `issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }`;
    return `query ${$557b489490412bcc$export$33da63e9ed5a1c48} ($boardId: ID!, $useBackendIccConfig: Boolean!, $showIssueTransition: Boolean!, $hasJqlFilter: Boolean!, $filterJql: String) {
            boardScope(boardId: $boardId, filterJql: $filterJql) {
                userSwimlaneStrategy
                board {
                    name
                    swimlaneStrategy
                    hasClearedIssues
                    rankCustomFieldId
                    filteredCardIds @include(if: $hasJqlFilter)
                    assignees {
                        accountId
                        displayName
                        avatarUrl
                    }
                    columns {
                        id
                        name
                        maxIssueCount
                        status {
                            id
                            name
                        }
                        ${$557b489490412bcc$export$48a92d19f93c7dd6}
                        isDone
                        isInitial
                        cards {
                            id
                            flagged
                            done
                            parentId
                            estimate {
                                storyPoints
                                originalEstimate {
                                    value
                                    valueAsText
                                }
                            }
                            issue {
                                id
                                key
                                summary
                                labels
                                assignee {
                                    accountId
                                }
                                type { id, name, iconUrl }
                                status { id }
                                activeSprint { id }
                            }
                            priority {
                                name
                                iconUrl
                            }
                            dueDate
                            childIssuesMetadata { complete, total }
                        }
                    }
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                    inlineIssueCreate @skip(if: $useBackendIccConfig) { enabled }
                    ${issueChildren}
                    cards { id }
                    ${$557b489490412bcc$export$225522b2e3455b2}
                    inlineCardCreateConfig @include(if: $useBackendIccConfig)
                }
                sprints(state: [ACTIVE]) {
                    id
                    name
                    goal
                    startDate
                    endDate
                    daysRemaining
                }
                features { key, status, toggle, category }
                projectLocation {
                    id
                    key
                    name
                    isSimplifiedProject
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                }
                issueParents {
                    id
                    key
                    summary
                    issue {
                        status {
                            id
                            name
                            category
                        }
                    }
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
                currentUser { permissions }
                estimation {
                    current {
                        customFieldId
                    }
                }
            }
        }`;
};

});

parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $2nKjG = parcelRequire("2nKjG");

var $dJl1T = parcelRequire("dJl1T");

var $kobfu = parcelRequire("kobfu");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $dJl1T.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $7Jxgt.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $2nKjG.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});

parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $dJl1T = parcelRequire("dJl1T");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $dJl1T.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $dJl1T.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});



parcelRegister("l9rGV", function(module, exports) {

$parcel$export(module.exports, "boardScopeDataCriticalAnalyticsOptions", () => $704c21e5cce64332$export$6d18ac14fb11db9a);
const $704c21e5cce64332$var$APP_METRIC_KEY = 'software.next-gen.boards';
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY = `${$704c21e5cce64332$var$APP_METRIC_KEY}.boardscope.critical`;
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO = 1000;
const $704c21e5cce64332$export$6d18ac14fb11db9a = {
    analyticKey: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY,
    slo: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO
};

});





//# sourceMappingURL=get-data.5cc9c8a4.js.map
